import { Head } from "@inertiajs/react";
import AppLayout from "@/Layouts/MainAppLayout.jsx";
import { Box } from "@mui/material";
import { H1, H4, Paragraph } from "@/components/Typography";

export default ({ auth, categories, canResetPassword }) => {
    return (
        <>
            <Head title={"Terms And Conditions"} />
            <AppLayout
                categories={categories}
                auth={auth}
                canResetPassword={canResetPassword}
            >
                <Box mt={4} mb={8} px={2}>
                    <H1 style={{ textAlign: "center" }}>Privacy Policy</H1>
                    <Box sx={{ mt: 2, maxWidth: "1000px", mx: "auto" }}>
                        <Paragraph>
                            <b>At InfiniMall, we are committed to protecting your
                            privacy</b>. This Privacy Policy outlines how we
                            collect, use, and protect your personal information
                            when you use our website and services. By using our
                            website, you consent to the practices described in
                            this policy.
                        </Paragraph>
                        <Box mt={2}>
                            <H4>1. Information We Collect</H4>
                            <Paragraph>
                                <ul>
                                    <li><b>a. Personal Information</b></li>
                                    <ul>
                                        <li>
                                            When you make a purchase or create
                                            an account, we collect personal
                                            information, including:
                                        </li>
                                        <li>- Full name</li>
                                        <li>- Email address</li>
                                        <li>- Phone number</li>
                                        <li>- Shipping and billing address</li>
                                        <li>
                                            - Payment information (credit card
                                            details, e-wallet information)
                                        </li>
                                        <li>- Order history</li>
                                    </ul>

                                    <li><b>b. Non-Personal Information</b></li>
                                    <ul>
                                        <li>
                                            We may collect non-personal
                                            information automatically when you
                                            visit our website, including:
                                        </li>
                                        <li>- IP address</li>
                                        <li>- Browser type</li>
                                        <li>- Device type</li>
                                        <li>- Page visit on the website</li>
                                        <li>- Date and time of your visit</li>
                                        <li>- Referring/exit pages</li>
                                    </ul>

                                    <li><b>c. Cookies</b></li>
                                    <li>
                                        We use cookies to enhance your browsing
                                        experience and collect data on site
                                        usage. Cookies are small text files that
                                        are stored on your device. You can
                                        control the use of cookies through your
                                        browser settings, but disabling cookies
                                        may limit your ability to use some
                                        features of the website.
                                    </li>
                                </ul>
                            </Paragraph>
                        </Box>
                        <Box mt={2}>
                            <H4>2. How We Use Your Information</H4>
                            <Paragraph>
                                We use your personal information for the
                                following purposes:
                                <ul>
                                    <li>
                                        - To process and fulfill your orders
                                    </li>
                                    <li>
                                        - To communicate with you regarding
                                        your orders or inquiries.
                                    </li>
                                    <li>
                                        - To send you marketing and promotional
                                        emails (you can opt out of these at any
                                        time)
                                    </li>
                                    <li>
                                        - To improve our website and customer
                                        service
                                    </li>
                                    <li>
                                        - To prevent fraudulent transactions
                                        and enhance security
                                    </li>
                                </ul>
                            </Paragraph>
                        </Box>

                        <Box mt={2}>
                            <H4>3. Sharing Your Information</H4>
                            <Paragraph>
                                We do not sell, rent, or trade your personal
                                information to third parties. However, we may
                                share your information in the following
                                situations:
                                <ul>
                                    <li>
                                        <b>a. Service Providers</b>: We may share your
                                        information with trusted third-party
                                        service providers (e.g., payment
                                        processors, shipping companies, email
                                        marketing platforms) to assist us in
                                        providing our services. These parties
                                        are obligated to protect your
                                        information and only use it for the
                                        purposes for which we have shared it.
                                    </li>
                                    <li>
                                        <b>b. Legal Compliance</b>: We may disclose
                                        your information if required to do so by
                                        law, such as to comply with a subpoena,
                                        court order, or other legal process.
                                    </li>
                                    <li>
                                        <b>c. Business Transfers</b>: In the event of a
                                        merger, acquisition, or sale of assets,
                                        your personal information may be
                                        transferred as part of the transaction.
                                    </li>
                                </ul>
                            </Paragraph>
                        </Box>

                        <Box mt={2}>
                            <H4>4. Data Security</H4>
                            <Paragraph>
                                We take the security of your personal
                                information seriously and implement appropriate
                                technical and organizational measures to protect
                                your data from unauthorized access, alteration,
                                or destruction. However, no method of
                                transmission over the internet or method of
                                electronic storage is 100% secure, and we cannot
                                guarantee the absolute security of your
                                information.
                            </Paragraph>
                        </Box>

                        <Box mt={2}>
                            <H4>5. Your Rights and Choices</H4>
                            <Paragraph>
                                You have the right to:
                                <ul>
                                    <li>
                                        <b>a. Access</b>: Request a copy of the
                                        personal information we hold about you.
                                    </li>
                                    <li>
                                        <b>b. Correct</b>: Update or correct any
                                        inaccuracies in your personal
                                        information.
                                    </li>
                                    <li>
                                        <b>c. Delete</b>: Request the deletion of your
                                        personal information (subject to certain
                                        legal exceptions).
                                    </li>
                                    <li>
                                        <b>d. Opt-Out</b>: Opt out of receiving
                                        promotional emails or marketing
                                        communications by following the
                                        unsubscribe link in our emails or
                                        contacting us directly.
                                    </li>
                                </ul>
                                To exercise these rights, please contact us at
                                helpdesk@infinimall.com.my.
                            </Paragraph>
                        </Box>

                        <Box mt={2}>
                            <H4>6. Retention of Your Data</H4>
                            <Paragraph>
                                We will retain your personal information for as
                                long as necessary to fulfill the purposes
                                outlined in this Privacy Policy, or as required
                                by law. Once the information is no longer
                                needed, it will be securely deleted or
                                anonymized.
                            </Paragraph>
                        </Box>
                        <Box mt={2}>
                            <H4>7. Third-Party Links</H4>
                            <Paragraph>
                                Our website may contain links to third-party
                                websites. We are not responsible for the privacy
                                practices or content of these external websites.
                                We encourage you to read the privacy policies of
                                any third-party sites you visit.
                            </Paragraph>
                        </Box>
                        <Box mt={2}>
                            <H4>8. Children’s Privacy</H4>
                            <Paragraph>
                                Our website is not intended for children under
                                the age of 13. We do not knowingly collect
                                personal information from children. If we learn
                                that we have inadvertently collected information
                                from a child under 13, we will delete it
                                immediately.
                            </Paragraph>
                        </Box>
                        <Box mt={2}>
                            <H4>9. Changes to This Privacy Policy</H4>
                            <Paragraph>
                                We reserve the right to update or change this
                                Privacy Policy at any time. When we do, we will
                                post the updated policy on this page with a new
                                effective date. We encourage you to review this
                                policy periodically to stay informed about how
                                we protect your information.
                            </Paragraph>
                        </Box>
                        <Box mt={2}>
                            <H4>10. Contact Us</H4>
                            <Paragraph>
                                If you have any questions or concerns about this
                                Privacy Policy, or if you wish to exercise any
                                of your rights regarding your personal
                                information, please contact us at:
                                <ul>
                                    <li>
                                        <b>Email</b>:{" "}
                                        <a href="mailto:helpdesk@infinimall.com.my">
                                            helpdesk@infinimall.com.my
                                        </a>
                                    </li>
                                    <li><b>Phone</b>: 03-32929219</li>
                                    <li>
                                        <b>Address</b>: NO. SUITE 18-03A & 18-05 , LEVEL 18,
                                        PLAZA AZALEA 10, PERSIARAN BANDARAYA,
                                        SEKSYEN 14,
                                        40000 SHAH ALAM,
                                        SELANGOR.
                                    </li>
                                </ul>
                            </Paragraph>
                        </Box>
                    </Box>
                </Box>
            </AppLayout>
        </>
    );
};
